import styles from "./ArtistBackground.module.scss";
import {ARTIST, Artist} from "../utils/artist.utils";
import backgroundRiize from "../assets/images/riize/background_riize.png";
import backgroundAespa from "../assets/images/aespa/background_aespa.png";

type ArtistBackgroundProps = {
  artist: Artist;
};

const ArtistBackground = ({artist}: ArtistBackgroundProps) => {
  const backgroundImage =
    artist === ARTIST.aespa ? backgroundAespa : backgroundRiize;

  return (
    <div className={styles.background}>
      <img src={backgroundImage} className={styles.image} alt="" />
    </div>
  );
};

export default ArtistBackground;
